import '@kraaapf/ui/styles';

import { VueQueryPlugin, type VueQueryPluginOptions } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from '@/app/App.vue';
import { router } from '@/app/router';

/**
 * Einstiegspunkt des Adminportals.
 *
 * ## Die Einstellungen von TanStack Query sind keine Vorgaben
 *
 * `staleTime: 0` und **kein** Abrufen im Hintergrund: Diese Oberfläche wird
 * über das Ereignisband aktuell gehalten, nicht über einen Takt. Ein
 * Wiederholungsintervall daneben wäre ein zweiter Weg zur selben Auskunft —
 * und bei einer Flotte, die alle zehn Sekunden Heartbeats schickt, ein
 * Dauerfeuer auf den Master.
 *
 * `retry: false`: Fehler werden **angezeigt**. Ein stiller dritter Versuch
 * verzögert die Meldung um Sekunden und verdeckt genau den Fall, um den es
 * geht — dass der Master gerade nicht antwortet.
 */
const queryOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchInterval: false,
        retry: false,
      },
      mutations: {
        retry: false,
      },
    },
  },
};

createApp(App).use(createPinia()).use(router).use(VueQueryPlugin, queryOptions).mount('#app');
